// import React, { useEffect, useState, useCallback } from 'react';
// import {
//   Box, Typography, IconButton, Chip, TextField, InputAdornment,
//   CircularProgress, Dialog, DialogContent, DialogActions, Button,
//   Select, MenuItem, FormControl, TablePagination,
// } from '@mui/material';
// import {
//   Visibility as EyeIcon,
//   Search as SearchIcon,
//   UnfoldMore as SortIcon,
//   KeyboardArrowUp as ArrowUpIcon,
//   KeyboardArrowDown as ArrowDownIcon,
//   Close as CloseIcon,
//   Http as HttpIcon,
// } from '@mui/icons-material';
// import api from "../../api/axiosInterceptor";

// // ─────────────────────────────────────────────
// // DESIGN TOKENS — reused from your dashboard components
// // ─────────────────────────────────────────────
// const T = {
//   pageBg: '#F0F4F8', cardBg: '#FFFFFF', border: '#E2E8F0',
//   shadow: '0 1px 4px rgba(0,0,0,0.06),0 4px 16px rgba(0,0,0,0.06)',
//   blue: '#3182CE', blueSoft: '#EBF8FF', blueMid: '#BEE3F8',
//   green: '#276749', greenSoft: '#F0FFF4', greenMid: '#9AE6B4',
//   red: '#C53030', redSoft: '#FFF5F5', redMid: '#FEB2B2',
//   amber: '#C05621', amberSoft: '#FFFAF0', amberMid: '#FBD38D',
//   purple: '#553C9A', purpleSoft: '#FAF5FF', purpleMid: '#D6BCFA',
//   textPrimary: '#1A202C', textSecondary: '#4A5568', textMuted: '#718096',
//   gradBlue: 'linear-gradient(135deg,#2B6CB0 0%,#3182CE 100%)',
// };

// // Method -> color
// const METHOD_COLORS = {
//   GET:    { color: T.blue,   soft: T.blueSoft,   mid: T.blueMid },
//   POST:   { color: T.green,  soft: T.greenSoft,  mid: T.greenMid },
//   PUT:    { color: T.amber,  soft: T.amberSoft,  mid: T.amberMid },
//   PATCH:  { color: T.amber,  soft: T.amberSoft,  mid: T.amberMid },
//   DELETE: { color: T.red,    soft: T.redSoft,    mid: T.redMid },
// };

// const MethodChip = ({ method }) => {
//   const c = METHOD_COLORS[method] || { color: T.textMuted, soft: '#F7FAFC', mid: T.border };
//   return (
//     <Chip label={method} size="small" sx={{
//       height: 22, fontSize: 11, fontWeight: 800,
//       bgcolor: c.soft, color: c.color, border: `1px solid ${c.mid}`,
//       minWidth: 62,
//     }} />
//   );
// };

// const StatusChip = ({ code }) => {
//   const isSuccess = code < 400;
//   const isServerErr = code >= 500;
//   const color = isServerErr ? T.red : isSuccess ? T.green : T.amber;
//   const soft  = isServerErr ? T.redSoft : isSuccess ? T.greenSoft : T.amberSoft;
//   const mid   = isServerErr ? T.redMid : isSuccess ? T.greenMid : T.amberMid;
//   return (
//     <Chip label={code} size="small" sx={{
//       height: 22, fontSize: 11, fontWeight: 800,
//       bgcolor: soft, color, border: `1px solid ${mid}`,
//     }} />
//   );
// };

// const SortableHeaderCell = ({ label, field, ordering, onSort, align = 'left' }) => {
//   const isActive = ordering === field || ordering === `-${field}`;
//   const isDesc = ordering === `-${field}`;
//   return (
//     <Box component="th" onClick={() => onSort(field)} sx={{
//       px: 2, py: 1.5, background: T.gradBlue, color: '#fff', fontSize: 12.5,
//       fontWeight: 700, cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap',
//       textAlign: align,
//     }}>
//       <Box display="flex" alignItems="center" gap={0.5} justifyContent={align === 'center' ? 'center' : 'flex-start'}>
//         {label}
//         {isActive
//           ? (isDesc ? <ArrowDownIcon sx={{ fontSize: 16 }} /> : <ArrowUpIcon sx={{ fontSize: 16 }} />)
//           : <SortIcon sx={{ fontSize: 15, opacity: 0.6 }} />}
//       </Box>
//     </Box>
//   );
// };

// // ─────────────────────────────────────────────
// // REQUEST DETAIL MODAL
// // ─────────────────────────────────────────────
// const RequestDetailsModal = ({ open, onClose, row }) => {
//   if (!row) return null;

//   const fields = [
//     ['User Name', row.name],
//     ['Role', row.role],
//     ['Method', row.method],
//     ['Endpoint', row.path],
//     ['Action', row.action_label || '—'],
//     ['Status Code', row.status_code],
//     ['Response Time', row.response_time_ms != null ? `${row.response_time_ms} ms` : '—'],
//     ['Query Params', row.query_params || '—'],
//     ['Request Body', row.request_body || '—'],
//     ['IP', row.ip_address || '—'],
//     ['Country', row.country || '—'],
//     ['State', row.state || '—'],
//     ['City', row.city || '—'],
//     ['Latitude', row.latitude || '—'],
//     ['Longitude', row.longitude || '—'],
//     ['Timezone', row.timezone || '—'],
//   ];

//   return (
//     <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth
//       PaperProps={{ sx: { borderRadius: '14px', overflow: 'hidden' } }}>
//       <Box sx={{ px: 3, py: 2, background: T.gradBlue, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//         <Box display="flex" alignItems="center" gap={1}>
//           <HttpIcon sx={{ color: '#fff', fontSize: 20 }} />
//           <Typography sx={{ color: '#fff', fontWeight: 700, fontSize: 15 }}>Request Details</Typography>
//         </Box>
//         <IconButton size="small" onClick={onClose} sx={{ color: '#fff' }}>
//           <CloseIcon fontSize="small" />
//         </IconButton>
//       </Box>

//       <DialogContent sx={{ p: 0, maxHeight: 480 }}>
//         <Box>
//           {fields.map(([label, value], i) => (
//             <Box key={label} display="flex" sx={{
//               px: 3, py: 1.1, background: i % 2 === 0 ? T.cardBg : '#F7FAFC',
//               borderBottom: `1px solid ${T.border}`,
//             }}>
//               <Typography sx={{ fontSize: 13, fontWeight: 700, color: T.textPrimary, width: 150, flexShrink: 0 }}>
//                 {label}
//               </Typography>
//               <Typography sx={{
//                 fontSize: 12.5, color: T.textSecondary, wordBreak: 'break-all',
//                 fontFamily: ['Endpoint', 'Query Params', 'Request Body'].includes(label) ? 'monospace' : 'inherit',
//               }}>
//                 :&nbsp;&nbsp;{value}
//               </Typography>
//             </Box>
//           ))}
//         </Box>
//       </DialogContent>

//       <DialogActions sx={{ p: 2 }}>
//         <Button onClick={onClose} variant="contained" sx={{
//           textTransform: 'none', fontWeight: 700, borderRadius: '8px',
//           background: T.blue, '&:hover': { background: '#2B6CB0' },
//         }}>
//           Close
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// // ─────────────────────────────────────────────
// // SUMMARY STRIP
// // ─────────────────────────────────────────────
// const SummaryChip = ({ label, value, color, soft }) => (
//   <Box sx={{
//     px: 2, py: 1, borderRadius: '10px', background: soft,
//     border: `1.5px solid ${color}40`, minWidth: 120,
//   }}>
//     <Typography sx={{ fontSize: 10, color, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.5 }}>
//       {label}
//     </Typography>
//     <Typography sx={{ fontSize: 18, fontWeight: 800, color: T.textPrimary }}>
//       {value}
//     </Typography>
//   </Box>
// );

// // ─────────────────────────────────────────────
// // MAIN — FULL ACTIVITY LOG (ALL USERS, ALL ENDPOINTS)
// // ─────────────────────────────────────────────
// export const ActivityLogsComponent = () => {
//   const [rows, setRows] = useState([]);
//   const [summary, setSummary] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [search, setSearch] = useState('');
//   const [methodFilter, setMethodFilter] = useState('');
//   const [statusFilter, setStatusFilter] = useState('');
//   const [ordering, setOrdering] = useState('-created');
//   const [page, setPage] = useState(0);
//   const [pageSize, setPageSize] = useState(15);
//   const [totalCount, setTotalCount] = useState(0);
//   const [modalRow, setModalRow] = useState(null);
//   const [modalOpen, setModalOpen] = useState(false);

//   const buildParams = useCallback(() => {
//     const params = new URLSearchParams();
//     if (search) params.append('search', search);
//     if (methodFilter) params.append('method', methodFilter);
//     if (statusFilter) params.append('status', statusFilter);
//     params.append('ordering', ordering);
//     params.append('page', page + 1);
//     params.append('page_size', pageSize);
//     return params.toString();
//   }, [search, methodFilter, statusFilter, ordering, page, pageSize]);

//   const fetchLogs = useCallback(() => {
//     setLoading(true);
//     api.get(`/auth/activity-logs/?${buildParams()}`)
//       .then((r) => {
//         setRows(r.data.results || []);
//         setTotalCount(r.data.count || 0);
//       })
//       .catch(() => { setRows([]); setTotalCount(0); })
//       .finally(() => setLoading(false));
//   }, [buildParams]);

//   const fetchSummary = useCallback(() => {
//     api.get('/auth/activity-logs/summary/')
//       .then((r) => setSummary(r.data))
//       .catch(() => setSummary(null));
//   }, []);

//   useEffect(() => {
//     const t = setTimeout(fetchLogs, search ? 350 : 0);
//     return () => clearTimeout(t);
//   }, [fetchLogs]);

//   useEffect(() => { fetchSummary(); }, [fetchSummary]);

//   const handleSort = (field) => {
//     setPage(0);
//     setOrdering((prev) => (prev === field ? `-${field}` : field));
//   };

//   const openDetails = (row) => { setModalRow(row); setModalOpen(true); };

//   return (
//     <Box sx={{ p: { xs: 2, md: 3 }, background: T.pageBg, minHeight: '100vh' }}>

//       {/* ── HEADER ── */}
//       <Typography sx={{ fontSize: 19, fontWeight: 800, color: T.textPrimary, mb: 0.5 }}>
//         Application Activity Log
//       </Typography>
//       <Typography sx={{ fontSize: 12.5, color: T.textMuted, mb: 2.5 }}>
//         Every API call across the application — all users, all endpoints, all methods.
//       </Typography>

//       {/* ── SUMMARY STRIP ── */}
//       {summary && (
//         <Box display="flex" gap={1.5} flexWrap="wrap" mb={2.5}>
//           <SummaryChip label="Total Calls" value={summary.total_calls} color={T.blue} soft={T.blueSoft} />
//           <SummaryChip label="Success" value={summary.success_calls} color={T.green} soft={T.greenSoft} />
//           <SummaryChip label="Errors" value={summary.error_calls} color={T.red} soft={T.redSoft} />
//           <SummaryChip label="Error Rate" value={`${summary.error_rate_pct}%`} color={T.amber} soft={T.amberSoft} />
//         </Box>
//       )}

//       {/* ── FILTER BAR ── */}
//       <Box display="flex" gap={1.5} flexWrap="wrap" mb={2}>
//         <TextField
//           size="small"
//           placeholder="Search name / endpoint / action..."
//           value={search}
//           onChange={(e) => { setPage(0); setSearch(e.target.value); }}
//           InputProps={{
//             startAdornment: (
//               <InputAdornment position="start"><SearchIcon sx={{ fontSize: 18, color: T.textMuted }} /></InputAdornment>
//             ),
//           }}
//           sx={{ minWidth: 260, '& .MuiOutlinedInput-root': { borderRadius: '10px', fontSize: 13, background: '#fff' } }}
//         />
//         <FormControl size="small" sx={{ minWidth: 130 }}>
//           <Select displayEmpty value={methodFilter}
//             onChange={(e) => { setPage(0); setMethodFilter(e.target.value); }}
//             sx={{ borderRadius: '10px', fontSize: 13, background: '#fff' }}>
//             <MenuItem value=""><em>All Methods</em></MenuItem>
//             {['GET', 'POST', 'PUT', 'PATCH', 'DELETE'].map((m) => (
//               <MenuItem key={m} value={m}>{m}</MenuItem>
//             ))}
//           </Select>
//         </FormControl>
//         <FormControl size="small" sx={{ minWidth: 130 }}>
//           <Select displayEmpty value={statusFilter}
//             onChange={(e) => { setPage(0); setStatusFilter(e.target.value); }}
//             sx={{ borderRadius: '10px', fontSize: 13, background: '#fff' }}>
//             <MenuItem value=""><em>All Status</em></MenuItem>
//             <MenuItem value="success">Success (2xx/3xx)</MenuItem>
//             <MenuItem value="error">Error (4xx/5xx)</MenuItem>
//           </Select>
//         </FormControl>

//         {/* Quick isolate — Login/Logout events, without a separate screen */}
//         <Chip
//           label="Login/Logout Only"
//           size="small"
//           onClick={() => { setPage(0); setSearch((prev) => (prev === 'login' ? '' : 'login')); }}
//           sx={{
//             height: 32, fontSize: 12.5, fontWeight: 700, cursor: 'pointer',
//             bgcolor: search === 'login' ? T.blue : '#fff',
//             color: search === 'login' ? '#fff' : T.textMuted,
//             border: `1.5px solid ${search === 'login' ? T.blue : T.border}`,
//             '&:hover': { bgcolor: search === 'login' ? T.blue : T.blueSoft },
//           }}
//         />
//       </Box>

//       {/* ── TABLE CARD ── */}
//       <Box sx={{ background: T.cardBg, borderRadius: '14px', border: `1.5px solid ${T.border}`, boxShadow: T.shadow, overflow: 'hidden' }}>
//         <Box sx={{ overflowX: 'auto' }}>
//           <Box component="table" sx={{ width: '100%', borderCollapse: 'collapse' }}>
//             <Box component="thead">
//               <Box component="tr">
//                 <Box component="th" sx={{ px: 2, py: 1.5, background: T.gradBlue, color: '#fff', fontSize: 12.5, fontWeight: 700, textAlign: 'left' }}>
//                   Sl.No
//                 </Box>
//                 <SortableHeaderCell label="Name"    field="name_snapshot"  ordering={ordering} onSort={handleSort} />
//                 <SortableHeaderCell label="Role"    field="role_snapshot"  ordering={ordering} onSort={handleSort} />
//                 <SortableHeaderCell label="Method"  field="method"         ordering={ordering} onSort={handleSort} align="center" />
//                 <Box component="th" sx={{ px: 2, py: 1.5, background: T.gradBlue, color: '#fff', fontSize: 12.5, fontWeight: 700, textAlign: 'left' }}>
//                   Endpoint / Action
//                 </Box>
//                 <SortableHeaderCell label="Status"  field="status_code"        ordering={ordering} onSort={handleSort} align="center" />
//                 <SortableHeaderCell label="Time (ms)" field="response_time_ms" ordering={ordering} onSort={handleSort} align="center" />
//                 <SortableHeaderCell label="When"    field="created"        ordering={ordering} onSort={handleSort} />
//                 <Box component="th" sx={{ px: 2, py: 1.5, background: T.gradBlue, color: '#fff', fontSize: 12.5, fontWeight: 700, textAlign: 'center' }}>
//                   Action
//                 </Box>
//               </Box>
//             </Box>

//             <Box component="tbody">
//               {loading && (
//                 <Box component="tr"><Box component="td" colSpan={9} sx={{ py: 5, textAlign: 'center' }}>
//                   <CircularProgress size={26} sx={{ color: T.blue }} />
//                 </Box></Box>
//               )}

//               {!loading && rows.length === 0 && (
//                 <Box component="tr"><Box component="td" colSpan={9} sx={{ py: 5, textAlign: 'center' }}>
//                   <Typography sx={{ fontSize: 13, color: T.textMuted }}>No activity found.</Typography>
//                 </Box></Box>
//               )}

//               {!loading && rows.map((row, i) => (
//                 <Box component="tr" key={row.id} sx={{
//                   background: i % 2 === 0 ? '#fff' : '#F7FAFC',
//                   '&:hover': { background: T.blueSoft }, transition: 'background 0.15s',
//                 }}>
//                   <Box component="td" sx={{ px: 2, py: 1.1, fontSize: 13, borderBottom: `1px solid ${T.border}` }}>
//                     {page * pageSize + i + 1}
//                   </Box>
//                   <Box component="td" sx={{ px: 2, py: 1.1, fontSize: 13, fontWeight: 600, color: T.textPrimary, borderBottom: `1px solid ${T.border}` }}>
//                     {row.name}
//                   </Box>
//                   <Box component="td" sx={{ px: 2, py: 1.1, fontSize: 13, color: T.textSecondary, borderBottom: `1px solid ${T.border}` }}>
//                     {row.role || '—'}
//                   </Box>
//                   <Box component="td" sx={{ px: 2, py: 1.1, textAlign: 'center', borderBottom: `1px solid ${T.border}` }}>
//                     <MethodChip method={row.method} />
//                   </Box>
//                   <Box component="td" sx={{ px: 2, py: 1.1, borderBottom: `1px solid ${T.border}` }}>
//                     <Typography sx={{ fontSize: 12.5, fontWeight: 600, color: T.textPrimary }}>
//                       {row.action_label || '—'}
//                     </Typography>
//                     <Typography sx={{ fontSize: 11, color: T.textMuted, fontFamily: 'monospace' }}>
//                       {row.path}
//                     </Typography>
//                   </Box>
//                   <Box component="td" sx={{ px: 2, py: 1.1, textAlign: 'center', borderBottom: `1px solid ${T.border}` }}>
//                     <StatusChip code={row.status_code} />
//                   </Box>
//                   <Box component="td" sx={{ px: 2, py: 1.1, textAlign: 'center', fontSize: 12.5, color: T.textSecondary, borderBottom: `1px solid ${T.border}` }}>
//                     {row.response_time_ms != null ? row.response_time_ms : '—'}
//                   </Box>
//                   <Box component="td" sx={{ px: 2, py: 1.1, fontSize: 12.5, color: T.textMuted, whiteSpace: 'nowrap', borderBottom: `1px solid ${T.border}` }}>
//                     {row.time}
//                   </Box>
//                   <Box component="td" sx={{ px: 2, py: 1.1, textAlign: 'center', borderBottom: `1px solid ${T.border}` }}>
//                     <IconButton size="small" onClick={() => openDetails(row)} sx={{
//                       color: T.purple, border: `1.5px solid ${T.purpleMid}`, background: T.purpleSoft,
//                       width: 30, height: 30, '&:hover': { background: T.purpleMid },
//                     }}>
//                       <EyeIcon sx={{ fontSize: 16 }} />
//                     </IconButton>
//                   </Box>
//                 </Box>
//               ))}
//             </Box>
//           </Box>
//         </Box>

//         <TablePagination
//           component="div"
//           count={totalCount}
//           page={page}
//           onPageChange={(_, newPage) => setPage(newPage)}
//           rowsPerPage={pageSize}
//           onRowsPerPageChange={(e) => { setPageSize(parseInt(e.target.value, 10)); setPage(0); }}
//           rowsPerPageOptions={[15, 25, 50, 100]}
//           sx={{ borderTop: `1.5px solid ${T.border}` }}
//         />
//       </Box>

//       <RequestDetailsModal open={modalOpen} onClose={() => setModalOpen(false)} row={modalRow} />
//     </Box>
//   );
// };

// export default ActivityLogsComponent;


import React, { useEffect, useState, useCallback } from 'react';
import {
  Box, Typography, IconButton, Chip, TextField, InputAdornment,
  CircularProgress, Dialog, DialogContent, DialogActions, Button,
  Select, MenuItem, FormControl, TablePagination,
} from '@mui/material';
import {
  Visibility as EyeIcon,
  Search as SearchIcon,
  UnfoldMore as SortIcon,
  KeyboardArrowUp as ArrowUpIcon,
  KeyboardArrowDown as ArrowDownIcon,
  Close as CloseIcon,
  Http as HttpIcon,
  FileDownload as DownloadIcon,
} from '@mui/icons-material';
import api from '../../api/axiosInterceptor';

// ─────────────────────────────────────────────
// DESIGN TOKENS — reused from your dashboard components
// ─────────────────────────────────────────────
const T = {
  pageBg: '#F0F4F8', cardBg: '#FFFFFF', border: '#E2E8F0',
  shadow: '0 1px 4px rgba(0,0,0,0.06),0 4px 16px rgba(0,0,0,0.06)',
  blue: '#3182CE', blueSoft: '#EBF8FF', blueMid: '#BEE3F8',
  green: '#276749', greenSoft: '#F0FFF4', greenMid: '#9AE6B4',
  red: '#C53030', redSoft: '#FFF5F5', redMid: '#FEB2B2',
  amber: '#C05621', amberSoft: '#FFFAF0', amberMid: '#FBD38D',
  purple: '#553C9A', purpleSoft: '#FAF5FF', purpleMid: '#D6BCFA',
  textPrimary: '#1A202C', textSecondary: '#4A5568', textMuted: '#718096',
  gradBlue: 'linear-gradient(135deg,#2B6CB0 0%,#3182CE 100%)',
};

// Method -> color
const METHOD_COLORS = {
  GET:    { color: T.blue,   soft: T.blueSoft,   mid: T.blueMid },
  POST:   { color: T.green,  soft: T.greenSoft,  mid: T.greenMid },
  PUT:    { color: T.amber,  soft: T.amberSoft,  mid: T.amberMid },
  PATCH:  { color: T.amber,  soft: T.amberSoft,  mid: T.amberMid },
  DELETE: { color: T.red,    soft: T.redSoft,    mid: T.redMid },
};

const MethodChip = ({ method }) => {
  const c = METHOD_COLORS[method] || { color: T.textMuted, soft: '#F7FAFC', mid: T.border };
  return (
    <Chip label={method} size="small" sx={{
      height: 22, fontSize: 11, fontWeight: 800,
      bgcolor: c.soft, color: c.color, border: `1px solid ${c.mid}`,
      minWidth: 62,
    }} />
  );
};

const StatusChip = ({ code }) => {
  const isSuccess = code < 400;
  const isServerErr = code >= 500;
  const color = isServerErr ? T.red : isSuccess ? T.green : T.amber;
  const soft  = isServerErr ? T.redSoft : isSuccess ? T.greenSoft : T.amberSoft;
  const mid   = isServerErr ? T.redMid : isSuccess ? T.greenMid : T.amberMid;
  return (
    <Chip label={code} size="small" sx={{
      height: 22, fontSize: 11, fontWeight: 800,
      bgcolor: soft, color, border: `1px solid ${mid}`,
    }} />
  );
};

const SortableHeaderCell = ({ label, field, ordering, onSort, align = 'left' }) => {
  const isActive = ordering === field || ordering === `-${field}`;
  const isDesc = ordering === `-${field}`;
  return (
    <Box component="th" onClick={() => onSort(field)} sx={{
      px: 2, py: 1.5, background: T.gradBlue, color: '#fff', fontSize: 12.5,
      fontWeight: 700, cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap',
      textAlign: align,
    }}>
      <Box display="flex" alignItems="center" gap={0.5} justifyContent={align === 'center' ? 'center' : 'flex-start'}>
        {label}
        {isActive
          ? (isDesc ? <ArrowDownIcon sx={{ fontSize: 16 }} /> : <ArrowUpIcon sx={{ fontSize: 16 }} />)
          : <SortIcon sx={{ fontSize: 15, opacity: 0.6 }} />}
      </Box>
    </Box>
  );
};

// ─────────────────────────────────────────────
// REQUEST DETAIL MODAL
// ─────────────────────────────────────────────
const RequestDetailsModal = ({ open, onClose, row }) => {
  if (!row) return null;

  const fields = [
    ['User Name', row.name],
    ['Role', row.role],
    ['Method', row.method],
    ['Endpoint', row.path],
    ['Action', row.action_label || '—'],
    ['Status Code', row.status_code],
    ['Response Time', row.response_time_ms != null ? `${row.response_time_ms} ms` : '—'],
    ['Query Params', row.query_params || '—'],
    ['Request Body', row.request_body || '—'],
    ['IP', row.ip_address || '—'],
    ['Country', row.country || '—'],
    ['State', row.state || '—'],
    ['City', row.city || '—'],
    ['Latitude', row.latitude || '—'],
    ['Longitude', row.longitude || '—'],
    ['Timezone', row.timezone || '—'],
  ];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth
      PaperProps={{ sx: { borderRadius: '14px', overflow: 'hidden' } }}>
      <Box sx={{ px: 3, py: 2, background: T.gradBlue, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Box display="flex" alignItems="center" gap={1}>
          <HttpIcon sx={{ color: '#fff', fontSize: 20 }} />
          <Typography sx={{ color: '#fff', fontWeight: 700, fontSize: 15 }}>Request Details</Typography>
        </Box>
        <IconButton size="small" onClick={onClose} sx={{ color: '#fff' }}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>

      <DialogContent sx={{ p: 0, maxHeight: 480 }}>
        <Box>
          {fields.map(([label, value], i) => (
            <Box key={label} display="flex" sx={{
              px: 3, py: 1.1, background: i % 2 === 0 ? T.cardBg : '#F7FAFC',
              borderBottom: `1px solid ${T.border}`,
            }}>
              <Typography sx={{ fontSize: 13, fontWeight: 700, color: T.textPrimary, width: 150, flexShrink: 0 }}>
                {label}
              </Typography>
              <Typography sx={{
                fontSize: 12.5, color: T.textSecondary, wordBreak: 'break-all',
                fontFamily: ['Endpoint', 'Query Params', 'Request Body'].includes(label) ? 'monospace' : 'inherit',
              }}>
                :&nbsp;&nbsp;{value}
              </Typography>
            </Box>
          ))}
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} variant="contained" sx={{
          textTransform: 'none', fontWeight: 700, borderRadius: '8px',
          background: T.blue, '&:hover': { background: '#2B6CB0' },
        }}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

// ─────────────────────────────────────────────
// SUMMARY STRIP
// ─────────────────────────────────────────────
const SummaryChip = ({ label, value, color, soft }) => (
  <Box sx={{
    px: 2, py: 1, borderRadius: '10px', background: soft,
    border: `1.5px solid ${color}40`, minWidth: 120,
  }}>
    <Typography sx={{ fontSize: 10, color, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.5 }}>
      {label}
    </Typography>
    <Typography sx={{ fontSize: 18, fontWeight: 800, color: T.textPrimary }}>
      {value}
    </Typography>
  </Box>
);

// ─────────────────────────────────────────────
// MAIN — FULL ACTIVITY LOG (ALL USERS, ALL ENDPOINTS)
// ─────────────────────────────────────────────
export const ActivityLogsComponent = () => {
  const [rows, setRows] = useState([]);
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [methodFilter, setMethodFilter] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [ordering, setOrdering] = useState('-created');
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(15);
  const [totalCount, setTotalCount] = useState(0);
  const [modalRow, setModalRow] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [exporting, setExporting] = useState(false);

  const buildParams = useCallback(({ forList = true } = {}) => {
    const params = new URLSearchParams();
    if (search) params.append('search', search);
    if (methodFilter) params.append('method', methodFilter);
    if (statusFilter) params.append('status', statusFilter);
    if (startDate) params.append('start_date', startDate);
    if (endDate) params.append('end_date', endDate);
    if (forList) {
      params.append('ordering', ordering);
      params.append('page', page + 1);
      params.append('page_size', pageSize);
    }
    return params.toString();
  }, [search, methodFilter, statusFilter, startDate, endDate, ordering, page, pageSize]);

  const fetchLogs = useCallback(() => {
    setLoading(true);
    api.get(`/auth/activity-logs/?${buildParams()}`)
      .then((r) => {
        setRows(r.data.results || []);
        setTotalCount(r.data.count || 0);
      })
      .catch(() => { setRows([]); setTotalCount(0); })
      .finally(() => setLoading(false));
  }, [buildParams]);

  const fetchSummary = useCallback(() => {
    const dateParams = new URLSearchParams();
    if (startDate) dateParams.append('start_date', startDate);
    if (endDate) dateParams.append('end_date', endDate);
    api.get(`/auth/activity-logs/summary/?${dateParams.toString()}`)
      .then((r) => setSummary(r.data))
      .catch(() => setSummary(null));
  }, [startDate, endDate]);

  useEffect(() => {
    const t = setTimeout(fetchLogs, search ? 350 : 0);
    return () => clearTimeout(t);
  }, [fetchLogs]);

  useEffect(() => { fetchSummary(); }, [fetchSummary]);

  // ── Export to CSV — exports ALL matching rows (not just current page),
  // using the same filters currently applied to the table.
  const handleExportCSV = useCallback(() => {
    if (exporting) return;
    setExporting(true);

    api.get(
      `/auth/activity-logs/export/?${buildParams({ forList: false })}`,
      { responseType: 'blob' }
    )
      .then((response) => {
        const disposition = response.headers?.['content-disposition'] || '';
        const match = disposition.match(/filename="?([^"]+)"?/);
        const filename = match ? match[1] : `activity_log_${new Date().toISOString().slice(0, 10)}.csv`;

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      })
      .finally(() => setExporting(false));
  }, [buildParams, exporting]);

  const handleSort = (field) => {
    setPage(0);
    setOrdering((prev) => (prev === field ? `-${field}` : field));
  };

  const openDetails = (row) => { setModalRow(row); setModalOpen(true); };

  return (
    <Box sx={{ p: { xs: 2, md: 3 }, background: T.pageBg, minHeight: '100vh' }}>

      {/* ── HEADER ── */}
      <Typography sx={{ fontSize: 19, fontWeight: 800, color: T.textPrimary, mb: 0.5 }}>
        Application Activity Log
      </Typography>
      <Typography sx={{ fontSize: 12.5, color: T.textMuted, mb: 2.5 }}>
        Every API call across the application — all users, all endpoints, all methods.
      </Typography>

      {/* ── SUMMARY STRIP ── */}
      {summary && (
        <Box display="flex" gap={1.5} flexWrap="wrap" mb={2.5}>
          <SummaryChip label="Total Calls" value={summary.total_calls} color={T.blue} soft={T.blueSoft} />
          <SummaryChip label="Success" value={summary.success_calls} color={T.green} soft={T.greenSoft} />
          <SummaryChip label="Errors" value={summary.error_calls} color={T.red} soft={T.redSoft} />
          <SummaryChip label="Error Rate" value={`${summary.error_rate_pct}%`} color={T.amber} soft={T.amberSoft} />
        </Box>
      )}

      {/* ── FILTER BAR ── */}
      <Box display="flex" gap={1.5} flexWrap="wrap" alignItems="center" mb={2}>
        <TextField
          size="small"
          placeholder="Search name / endpoint / action..."
          value={search}
          onChange={(e) => { setPage(0); setSearch(e.target.value); }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start"><SearchIcon sx={{ fontSize: 18, color: T.textMuted }} /></InputAdornment>
            ),
          }}
          sx={{ minWidth: 240, '& .MuiOutlinedInput-root': { borderRadius: '10px', fontSize: 13, background: '#fff' } }}
        />
        <FormControl size="small" sx={{ minWidth: 120 }}>
          <Select displayEmpty value={methodFilter}
            onChange={(e) => { setPage(0); setMethodFilter(e.target.value); }}
            sx={{ borderRadius: '10px', fontSize: 13, background: '#fff' }}>
            <MenuItem value=""><em>All Methods</em></MenuItem>
            {['GET', 'POST', 'PUT', 'PATCH', 'DELETE'].map((m) => (
              <MenuItem key={m} value={m}>{m}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl size="small" sx={{ minWidth: 130 }}>
          <Select displayEmpty value={statusFilter}
            onChange={(e) => { setPage(0); setStatusFilter(e.target.value); }}
            sx={{ borderRadius: '10px', fontSize: 13, background: '#fff' }}>
            <MenuItem value=""><em>All Status</em></MenuItem>
            <MenuItem value="success">Success (2xx/3xx)</MenuItem>
            <MenuItem value="error">Error (4xx/5xx)</MenuItem>
          </Select>
        </FormControl>

        {/* ── DATE RANGE ── */}
        <TextField
          size="small" label="From Date" type="date"
          value={startDate}
          onChange={(e) => { setPage(0); setStartDate(e.target.value); }}
          InputLabelProps={{ shrink: true }}
          sx={{ minWidth: 150, '& .MuiOutlinedInput-root': { borderRadius: '10px', fontSize: 13, background: '#fff' }, '& label': { fontSize: 12.5 } }}
        />
        <TextField
          size="small" label="To Date" type="date"
          value={endDate}
          onChange={(e) => { setPage(0); setEndDate(e.target.value); }}
          InputLabelProps={{ shrink: true }}
          sx={{ minWidth: 150, '& .MuiOutlinedInput-root': { borderRadius: '10px', fontSize: 13, background: '#fff' }, '& label': { fontSize: 12.5 } }}
        />
        {(startDate || endDate) && (
          <Chip
            label="Clear Dates" size="small" onClick={() => { setStartDate(''); setEndDate(''); setPage(0); }}
            sx={{ height: 32, fontSize: 12, fontWeight: 600, cursor: 'pointer', bgcolor: '#fff', border: `1.5px solid ${T.border}`, color: T.textMuted }}
          />
        )}

        {/* Quick isolate — Login/Logout events, without a separate screen */}
        <Chip
          label="Login/Logout Only"
          size="small"
          onClick={() => { setPage(0); setSearch((prev) => (prev === 'login' ? '' : 'login')); }}
          sx={{
            height: 32, fontSize: 12.5, fontWeight: 700, cursor: 'pointer',
            bgcolor: search === 'login' ? T.blue : '#fff',
            color: search === 'login' ? '#fff' : T.textMuted,
            border: `1.5px solid ${search === 'login' ? T.blue : T.border}`,
            '&:hover': { bgcolor: search === 'login' ? T.blue : T.blueSoft },
          }}
        />

        {/* ── EXPORT CSV ── */}
        <Box flex={1} />
        <Box
          onClick={handleExportCSV}
          sx={{
            display: 'flex', alignItems: 'center', gap: 0.75,
            px: 1.75, height: 36, borderRadius: '10px', cursor: exporting ? 'not-allowed' : 'pointer',
            background: exporting ? '#F7FAFC' : T.greenSoft,
            border: `1.5px solid ${exporting ? T.border : T.greenMid}`,
            color: exporting ? T.textMuted : T.green,
            userSelect: 'none', transition: 'all 0.2s',
            '&:hover': exporting ? {} : { background: T.greenMid, borderColor: T.green },
          }}
        >
          {exporting ? <CircularProgress size={14} sx={{ color: T.green }} /> : <DownloadIcon sx={{ fontSize: 16 }} />}
          <Typography sx={{ fontSize: 12, fontWeight: 700 }}>
            {exporting ? 'Exporting…' : 'Export CSV'}
          </Typography>
        </Box>
      </Box>

      {/* ── TABLE CARD ── */}
      <Box sx={{ background: T.cardBg, borderRadius: '14px', border: `1.5px solid ${T.border}`, boxShadow: T.shadow, overflow: 'hidden' }}>
        <Box sx={{ overflowX: 'auto' }}>
          <Box component="table" sx={{ width: '100%', borderCollapse: 'collapse' }}>
            <Box component="thead">
              <Box component="tr">
                <Box component="th" sx={{ px: 2, py: 1.5, background: T.gradBlue, color: '#fff', fontSize: 12.5, fontWeight: 700, textAlign: 'left' }}>
                  Sl.No
                </Box>
                <SortableHeaderCell label="Name"    field="name_snapshot"  ordering={ordering} onSort={handleSort} />
                <SortableHeaderCell label="Role"    field="role_snapshot"  ordering={ordering} onSort={handleSort} />
                <SortableHeaderCell label="Method"  field="method"         ordering={ordering} onSort={handleSort} align="center" />
                <Box component="th" sx={{ px: 2, py: 1.5, background: T.gradBlue, color: '#fff', fontSize: 12.5, fontWeight: 700, textAlign: 'left' }}>
                  Endpoint / Action
                </Box>
                <SortableHeaderCell label="Status"  field="status_code"        ordering={ordering} onSort={handleSort} align="center" />
                <SortableHeaderCell label="Time (ms)" field="response_time_ms" ordering={ordering} onSort={handleSort} align="center" />
                <SortableHeaderCell label="When"    field="created"        ordering={ordering} onSort={handleSort} />
                <Box component="th" sx={{ px: 2, py: 1.5, background: T.gradBlue, color: '#fff', fontSize: 12.5, fontWeight: 700, textAlign: 'center' }}>
                  Action
                </Box>
              </Box>
            </Box>

            <Box component="tbody">
              {loading && (
                <Box component="tr"><Box component="td" colSpan={9} sx={{ py: 5, textAlign: 'center' }}>
                  <CircularProgress size={26} sx={{ color: T.blue }} />
                </Box></Box>
              )}

              {!loading && rows.length === 0 && (
                <Box component="tr"><Box component="td" colSpan={9} sx={{ py: 5, textAlign: 'center' }}>
                  <Typography sx={{ fontSize: 13, color: T.textMuted }}>No activity found.</Typography>
                </Box></Box>
              )}

              {!loading && rows.map((row, i) => (
                <Box component="tr" key={row.id} sx={{
                  background: i % 2 === 0 ? '#fff' : '#F7FAFC',
                  '&:hover': { background: T.blueSoft }, transition: 'background 0.15s',
                }}>
                  <Box component="td" sx={{ px: 2, py: 1.1, fontSize: 13, borderBottom: `1px solid ${T.border}` }}>
                    {page * pageSize + i + 1}
                  </Box>
                  <Box component="td" sx={{ px: 2, py: 1.1, fontSize: 13, fontWeight: 600, color: T.textPrimary, borderBottom: `1px solid ${T.border}` }}>
                    {row.name}
                  </Box>
                  <Box component="td" sx={{ px: 2, py: 1.1, fontSize: 13, color: T.textSecondary, borderBottom: `1px solid ${T.border}` }}>
                    {row.role || '—'}
                  </Box>
                  <Box component="td" sx={{ px: 2, py: 1.1, textAlign: 'center', borderBottom: `1px solid ${T.border}` }}>
                    <MethodChip method={row.method} />
                  </Box>
                  <Box component="td" sx={{ px: 2, py: 1.1, borderBottom: `1px solid ${T.border}` }}>
                    <Typography sx={{ fontSize: 12.5, fontWeight: 600, color: T.textPrimary }}>
                      {row.action_label || '—'}
                    </Typography>
                    <Typography sx={{ fontSize: 11, color: T.textMuted, fontFamily: 'monospace' }}>
                      {row.path}
                    </Typography>
                  </Box>
                  <Box component="td" sx={{ px: 2, py: 1.1, textAlign: 'center', borderBottom: `1px solid ${T.border}` }}>
                    <StatusChip code={row.status_code} />
                  </Box>
                  <Box component="td" sx={{ px: 2, py: 1.1, textAlign: 'center', fontSize: 12.5, color: T.textSecondary, borderBottom: `1px solid ${T.border}` }}>
                    {row.response_time_ms != null ? row.response_time_ms : '—'}
                  </Box>
                  <Box component="td" sx={{ px: 2, py: 1.1, fontSize: 12.5, color: T.textMuted, whiteSpace: 'nowrap', borderBottom: `1px solid ${T.border}` }}>
                    {row.time}
                  </Box>
                  <Box component="td" sx={{ px: 2, py: 1.1, textAlign: 'center', borderBottom: `1px solid ${T.border}` }}>
                    <IconButton size="small" onClick={() => openDetails(row)} sx={{
                      color: T.purple, border: `1.5px solid ${T.purpleMid}`, background: T.purpleSoft,
                      width: 30, height: 30, '&:hover': { background: T.purpleMid },
                    }}>
                      <EyeIcon sx={{ fontSize: 16 }} />
                    </IconButton>
                  </Box>
                </Box>
              ))}
            </Box>
          </Box>
        </Box>

        <TablePagination
          component="div"
          count={totalCount}
          page={page}
          onPageChange={(_, newPage) => setPage(newPage)}
          rowsPerPage={pageSize}
          onRowsPerPageChange={(e) => { setPageSize(parseInt(e.target.value, 10)); setPage(0); }}
          rowsPerPageOptions={[15, 25, 50, 100]}
          sx={{ borderTop: `1.5px solid ${T.border}` }}
        />
      </Box>

      <RequestDetailsModal open={modalOpen} onClose={() => setModalOpen(false)} row={modalRow} />
    </Box>
  );
};

export default ActivityLogsComponent;